<template>
  <div class="login-main">
    <!-- 登录主题 -->
    <div class="input-main">
      <div class="login-title">欢迎登录</div>
      <div>
        <div class="label">账号</div>
        <div>
          <el-input v-model="loginInfo.loginName" placeholder="请输入账号" clearable></el-input>
        </div>
      </div>

      <div>
        <div class="label">密码</div>
        <div>
          <el-input v-model="loginInfo.pwd" type="password" placeholder="请输入密码" clearable ></el-input>
        </div>
      </div>

      <!-- <div>
        <div class="label">验证码</div>
        <div>
          <el-row>
            <el-col :span="17">
              <el-input v-model="loginInfo.verificationCode" placeholder="请输入验证码" clearable></el-input>
            </el-col>
            <el-col :span="5">
              <VerifyCode />
            </el-col>
          </el-row>
        </div>
      </div> -->

      <div>
        <el-button type="primary" class="btn" style="width: 100%" @click="login" :loading="isLoading">
          登录
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
// import VerifyCode from '../../components/VerificationCode'
import { getLogin } from '../../api/login.js'
export default {
  // components: {
  //   VerifyCode,
  // },
  data() {
    return {
      loginInfo: {
        loginName: '',
        pwd: '',
        // verificationCode: '',
      },
      isLoading : false,
    }
  },
  methods: {
    login() {
      if (!this.loginInfo.loginName) {
        this.msgerror('请输入账号')
        return
      }
      if (!this.loginInfo.pwd) {
        this.msgerror('请输入密码')
        return
      }
      // if (!this.loginInfo.verificationCode) {
      //   this.msgerror('请输入验证码')
      //   return
      // }
      // 调用登录方法
      console.info(this.loginInfo)
      getLogin(this.loginInfo)
        .then((res) => {
          if(res.code == 200){
            this.isLoading = true
            this.msgsuccess('登录成功')
            this.isLoading = false
            const token = res.data.token
            localStorage.setItem("token",token)
            const userInfo = JSON.stringify(this.loginInfo)
            localStorage.setItem("userInfo",userInfo)
            const menus = res.data.menus
            this.$store.commit('setMenus', menus)
            this.$router.replace('/home')
          }else{
            this.msgerror(res.msg)
          }
        })
        .catch(() => {
          this.msgerror('登录失败')
        })
    },
  },
}
</script>

<style scoped lang="less">
.login-main {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url('../../assets/loginbg2.jpg');
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .input-main {
    width: 500px;
    height: 400px;
    background-color: white;
    border-radius: 5px;
    padding: 0px 40px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 20px;
  }
}
.login-title {
  color: #409eff;
  font-size: 28px;
  font-weight: 700;
}
.label {
  margin-bottom: 10px;
}
.btn{
  margin-top: 20px;
  font-size: 20px;
}
</style>